import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react'
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import TableCustom from '../../../../components/table/tableCustom';
import { BookingMeetingRoomEquipmentApi, BookingMeetingRoomEquipmentListType, equipment_booking_data } from '../../../../api/booking-meeting-room-equipment/booking-meeting-room.api';
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { icons } from '../../../../assets/icons/icons';
import ModalEquipment from './ModalEquipment';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import { produce } from 'immer';

type Props = {
    view?: boolean;
    id_meeting_room: number;
    id_room_meeting: number;
    is_personal?: boolean;
}

const ItemsDetail: React.FC<Props> = ({ is_personal, id_meeting_room, view, id_room_meeting }: Props) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();



    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, setData] = useState<any[]>([]);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [search_equipment, set_search_equipment] = useState<any>(null);
    const [qty, set_qty] = useState<string>("");
    const [mode_option, set_mode_option] = useState<'VIEW' | 'EDIT' | ''>("");

    const [isChecked, setIsChecked] = useState<number[]>([]);

    const [list_equipment_data, set_list_equipment_data] = useState<any[]>([]);
    const [list_base_equipments_master_data, set_list_base_equipments_master_data] = useState<any[]>([]);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }
    // const toggleChecked = (id: number) => {
    //     setIsChecked(prev =>
    //         produce(prev, draft => {
    //             const index = draft.indexOf(id);
    //             if (index !== -1) {
    //                 draft.splice(index, 1);
    //             } else {
    //                 draft.push(id);
    //             }
    //         })
    //     );
    // };


    const headCells = [
        {
            id: "subject_no", width: 60, sortable: false, disablePadding: false, align: 'center', label: "ลำดับ"
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: "รหัสอุปกรณ์"
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: "ชื่ออุปกรณ์"
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: "จำนวน"
        },
        ...(is_personal ? [] : [
            {
                id: "a", disablePadding: false, align: "center", width: 141, label: "ค่าบริการ/หน่วย"
            },
            {
                id: "ab", disablePadding: false, align: "center", width: 141, label: "ค่าบริการรวม"
            },
        ]),
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 100, class: matches && data.length > 0, label: "สถานะ"
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            equipment_name,
            equipment_no,
            internal_service_fees,
            external_service_fees,
            id_meeting_room_equipment,
            qty
        } =
            objData;

        const all_internal_service_fees = Number(qty || "0") * Number(internal_service_fees || 0);
        const all_external_service_fees = Number(qty || "0") * Number(external_service_fees || 0);

        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: equipment_no || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: equipment_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: qty || "-"
                },
                ...(is_personal ? [] : [
                    {
                        option: "TEXT",
                        align: "center",
                        label: (internal_service_fees || "") + "(THB) หรือ " + (external_service_fees || "") + "(USD)"
                    },
                    {
                        option: "TEXT",
                        align: "center",
                        label: (all_internal_service_fees || "") + "(THB) หรือ " + (all_external_service_fees || "") + "(USD)"
                    },
                ]),

                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit={!view}
                            enableView
                            enableDelete={!view}
                            onViewClick={() => {
                                // navigate(routeName.public.classroom_meeting_booking_view.replace(":id", id_meeting_room))
                                setShowModal(true);
                                set_search_equipment({ ...objData, qty: String(qty || "") });
                                set_qty(String(qty || ""));
                                set_mode_option("VIEW");
                            }}
                            onEditClick={() => {
                                // navigate(routeName.public.classroom_meeting_booking_detail.replace(":id", id_meeting_room))
                                setShowModal(true);
                                set_search_equipment({ ...objData, qty: String(qty || "") });
                                set_qty(String(qty || ""));
                                set_mode_option("EDIT");
                            }}
                            onDeleteClick={() => {
                                id_meeting_room_equipment && handleDeleteList(id_meeting_room_equipment)
                            }}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_meeting_room_equipment: number) => {
        alertActive("ลบรายการ", "ต้องการลบรายการ หรือไม่?", undefined, undefined, async () => {
            dispatch(setLoading());
            await BookingMeetingRoomEquipmentApi.deleteBookingEquipment(id_meeting_room_equipment).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว")
                    handleGetListBookingEquipment();
                }
            }).catch((err) => {
                console.log(err)
                alertError("ลบรายการ", "ลบรายการ ไม่สำเร็จ")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const checkedDeleted = async (id_equipment: number) => {
        const id_meeting_room_equipment = list_equipment_data?.find((x) => x?.id_equipment == id_equipment)?.id_meeting_room_equipment;
        await BookingMeetingRoomEquipmentApi.deleteBookingEquipment(id_meeting_room_equipment).then((res) => {
            if (res.status < 300) {
                setIsChecked([])
                handleGetListBookingEquipment();
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    const handleGetListBookingEquipment = useCallback(async () => {
        let query: BookingMeetingRoomEquipmentListType = {
            page: page,
            limit: pageLimit,
            id_meeting_room: id_meeting_room,
            id_room_meeting
        }
        dispatch(setLoading());
        await BookingMeetingRoomEquipmentApi.listEquipment(query).then((res) => {
            if (res.status < 300) {
                const response: any[] = res.data?.data?.list_base_equipments || [];
                const list_base_equipments_master: any[] = res.data?.data?.list_base_equipments_master || [];
                if (response?.length > 0) {
                    const id_equipments = response?.map((list) => list?.id_equipment);
                    setIsChecked(id_equipments);
                }
                if (list_base_equipments_master?.length > 0) {
                    set_list_base_equipments_master_data(list_base_equipments_master || []);
                }
                const list_items: any[] = res.data?.data?.items || [];
                setData(list_items);
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
                set_list_equipment_data(response);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType])

    const handleToggleBaseEquipment = async (id_equipment: number) => {
        const body_data: equipment_booking_data[] = list_base_equipments_master_data?.filter((x) => x?.id_equipment === id_equipment).map((list) => {
            return {
                id_equipment: list?.id_equipment,
                id_meeting_room,
                id_room_meeting,
                meeting_room_equipment_type: "BASE",
                qty: list?.qty,
                status: "active"
            }
        })
        dispatch(setLoading());
        await BookingMeetingRoomEquipmentApi.createUpdateBookingEquipment(id_meeting_room, body_data).then((res) => {
            if (res.status < 300) {
                // const response = res.dataF
                handleGetListBookingEquipment();
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    const handleSubmitEquipment = async (body: equipment_booking_data[]) => {
        // let body_data: equipment_booking_data[] = [...body];

        dispatch(setLoading());
        await BookingMeetingRoomEquipmentApi.createUpdateBookingEquipment(id_meeting_room, body).then((res) => {
            if (res.status < 300) {
                // const response = res.dataF
                handleGetListBookingEquipment();
                alertSuccess("เพิ่มอุปกรณ์", "เพิ่มอุปกรณ์ เรียบร้อยแล้ว")
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }


    useEffect(() => {
        handleGetListBookingEquipment();
    }, [handleGetListBookingEquipment])


    return (
        <Box>
            <Box>
                <Typography variant='h6'>
                    อุปกรณ์ภายในห้อง
                </Typography>
                <Box>
                    {list_base_equipments_master_data?.map((list) => {
                        return (
                            <Box>
                                <CheckBoxCustom
                                    checked={isChecked.includes(list?.id_equipment)}
                                    label={list?.equipment_name || ""}
                                    disabled={view}
                                    setChecked={(st) => {
                                        // console.log(st, 'st')
                                        if (st) {
                                            handleToggleBaseEquipment(list?.id_equipment)
                                        } else {
                                            checkedDeleted(list?.id_equipment);
                                        }
                                    }}
                                // setChecked={() => toggleChecked(list?.id_equipment)}
                                />
                            </Box>
                        )
                    })}
                </Box>
            </Box>
            {!view && (
                <Box className="flex justify-end items-center">
                    <Button onClick={() => setShowModal(true)} variant='contained' color='success' startIcon={<icons.add2 />}>
                        เพิ่มอุปกรณ์
                    </Button>
                </Box>
            )}
            <Box className='w-full mt-4'>
                <TableCustom
                    tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={data?.map((data: any, i: any) => {
                        return renderData(data, i)
                    })}
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </Box>


            <ModalEquipment
                handleSubmit={handleSubmitEquipment}
                open={showModal}
                setShowModal={setShowModal}
                id_room_meeting={id_room_meeting}
                search_data={search_equipment}
                set_search_data={set_search_equipment}
                id_meeting_room={id_meeting_room}
                qty={qty}
                mode_option={mode_option}
                set_mode_option={set_mode_option}
                set_qty={set_qty}
            />
        </Box>
    )
}

export default ItemsDetail